import { toast } from "react-toastify";

import Icons from "../components/common/Icons";

export const SuccessToast = (message, className) => {
  toast(
    <div className="flex items-center gap-2">
      <Icons type="check1" />
      <span>{message}</span>
    </div>,
    {
      className: `bg-background-midnight gap-x-10 ${className}`,
      bodyClassName: "text-white text-medium",
      progressClassName: "bg-green-500",
      closeButton: ({ closeToast }) => (
        <button className="text-white text-large" onClick={closeToast}>
          <Icons type="close" />
        </button>
      ),
    },
  );
};

export const ErrorToast = (message, className) => {
  const formattedMessage = message.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));

  toast(
    <div className="flex items-center gap-2">
      <Icons type="checkError" className="w-[24px] h-[24px]" color="red" />
      <span>{formattedMessage}</span>
    </div>,
    {
      className: `bg-background-midnight ${className}`,
      bodyClassName: "text-white text-medium",
      progressClassName: "bg-red-500",
      closeButton: ({ closeToast }) => (
        <button className="text-white text-large" onClick={closeToast}>
          <Icons type="close" />
        </button>
      ),
    },
  );
};
